module.exports = __webpack_public_path__ + "img/san-jose-hotel-4.1cb4e4c5.jpg";